module.exports = __webpack_public_path__ + "img/ypy_logo5.6bdb8361.png";